import {
  BOA_KEY,
  cUrls,
  ftUrls,
  FT_KEY,
  VERSION,
} from "../../constants/ApiUrls";
import {
  deleteData,
  getData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getTabStatus = async (id) => {
  return await getData(BOA_KEY + VERSION + `boa/${id}/${cUrls.GET_TAB_VIEW}`);
};

export const updateTabStatus = async (dataObj, id) => {
  return await updateData(
    BOA_KEY + VERSION + `boa/${id}/${cUrls.UPDATE_TAB_VIEW}`,
    dataObj
  );
};
export const getFtTabStatus = async (id) => {
  let url =
    FT_KEY + VERSION + `familyTree/${id}/${cUrls.GET_FT_ABOUT_STATUS_VIEW}`;
  return await getData(url);
};

export const updateFtTabStatus = async (dataObj, id) => {
  let url =
    FT_KEY + VERSION + `familyTree/${id}/${cUrls.UPDATE_FT_ABOUT_STATUS_VIEW}`;

  return await updateData(url, dataObj);
};
export const updateImportTabDocument = async (dataObj, id) => {
  return await updateData(
    BOA_KEY + VERSION + `${id}/${cUrls.IMPORT_TAB_DOCUMENT}`,
    dataObj
  );
};
export const ImportTabDocument = async (dataObj, id) => {
  return await postData(
    BOA_KEY + VERSION + `${id}/${cUrls.IMPORT_TAB_DOCUMENT}`,
    dataObj
  );
};
export const getAssetsTabDocument = async (id, meta) => {
  const params = {
    pageSize: meta?.pageSize ? meta.pageSize : 0,
    pageNumber: meta?.pageNumber ? meta.pageNumber : 0,
    sortOrder: meta?.sortOrder ? meta.sortOrder : "asc",
  };
  return await getData(
    BOA_KEY +
      VERSION +
      `${id}/${cUrls.IMPORT_TAB_DOCUMENT}?&PageSize=${params.pageSize}&PageNumber=${params.pageNumber}&SortOrder=${params.sortOrder}`
  );
};

export const getSubChilds = async (key) => {
  return await getData(FT_KEY + VERSION + `${key}/${ftUrls.SUB_CHILDS}`);
};

export const deleteUserMediaBOA = async (userId, fileId) => {
  return await deleteData(
    BOA_KEY +
      VERSION +
      `${userId}/${cUrls.IMPORT_TAB_DOCUMENT}?boaUserMediaFileId=${fileId}`
  );
};
export const getUserMediaBOA = async (userId, fileId) => {
  return await getData(
    BOA_KEY +
      VERSION +
      `${userId}/${cUrls.DOWNLOAD_TAB_DOCUMENT}-by-id?boaUserMediaId=${fileId}`
  );
};
